import PmParcel from 'interfaces/PmParcel';
import APIError from 'exceptions/APIError';
import AppError from 'exceptions/AppError';
import { cancelReturnTicket } from '../fetchers';

export const cancelReturn = async ({
  orgId,
  returnUuid,
  returnStatus,
}: {
  orgId: number;
  returnUuid: string;
  returnStatus: string;
}): Promise<PmParcel> => {
  try {
    await cancelReturnTicket(orgId, returnUuid, {
      return_status: returnStatus,
    });
  } catch (error) {
    if (error instanceof APIError) {
      throw new AppError(error.message);
    }

    throw error;
  }
  return null;
};
